require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-video-las-politicas-de-salvaguardas-del-banco-mundial.json") })
        }
      }, "path---es-mx-update-video-las-politicas-de-salvaguardas-del-banco-mundial");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-video-las-politicas-de-salvaguardas-del-banco-mundial!./.cache/json/es-mx-update-video-las-politicas-de-salvaguardas-del-banco-mundial.json
// module id = 938
// module chunks = 231608221292675